import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productColSpan',
    standalone: true
})
export class ProductColSpanPipe implements PipeTransform {
    transform(colSpan?: number, rowSpan?: number, isBanner?: boolean, listingSize?: number): number {
        return productColSpan(colSpan, rowSpan, isBanner, listingSize);
    }
}

export function productColSpan(colSpan = 1, rowSpan = 1, isBanner = false, listingSize = 2): number {
    return colSpan === 2 && listingSize === 3 && !isBanner && !(rowSpan === 2) ? 3 : Math.max(1, Math.min(colSpan, listingSize));
}
